import React, { useState, useEffect } from 'react';
import { Card, Button, ListGroup, Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../css/Bills.css';
import { faCopy, faMinimize, faMaximize, faTrash } from '@fortawesome/free-solid-svg-icons';

const BillSelectionTotal = ({
  selectedBills,
  totalAmount,
  weeklyBudget,
  onClearAll,
  onMinimize
}) => {
  const [showBreakdown, setShowBreakdown] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Check if any modal is open
  useEffect(() => {
    const checkForModals = () => {
      const modalBackdrops = document.querySelectorAll('.modal-backdrop');
      const modals = document.querySelectorAll('.modal.show');
      setIsModalOpen(modalBackdrops.length > 0 || modals.length > 0);
    };
    
    // Check on component mount and whenever a mutation is detected
    checkForModals();
    
    // Set up a mutation observer to detect when modals are added/removed
    const observer = new MutationObserver(checkForModals);
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => observer.disconnect();
  }, []);
  
  const handleCopy = () => {
    if (isModalOpen) return;
    navigator.clipboard.writeText(totalAmount.toFixed(2));
  };

  const toggleMinimize = () => {
    if (isModalOpen) return;
    setIsMinimized(!isMinimized);
    onMinimize(!isMinimized);
  };

  const percentage = (totalAmount / weeklyBudget) * 100;

  // If a modal is open, don't render the component
  if (isModalOpen) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '0',
      right: '20px',
      zIndex: 9999,
      transform: 'translateY(80px)', // Use transform instead of top for better positioning
      maxWidth: '400px',
      backgroundColor: 'white',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      border: '1px solid rgba(0,0,0,0.1)',
      borderRadius: '4px'
    }}>
      <Card
        className="bill-selection-total"
        style={{
          backgroundColor: 'transparent',
          border: 'none'
        }}
      >
        <Card.Header 
          className="d-flex justify-content-between align-items-center bg-white" 
          style={{ 
            borderBottom: '1px solid rgba(0,0,0,0.1)',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px'
          }}>
          <span>Selected Bills</span>
          <div>
            <Button variant="link" onClick={handleCopy}>
              <FontAwesomeIcon icon={faCopy} />
            </Button>
            <Button variant="link" onClick={toggleMinimize}>
              <FontAwesomeIcon icon={isMinimized ? faMaximize : faMinimize} />
            </Button>
          </div>
        </Card.Header>
        <Card.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
          <div className="d-flex justify-content-between mb-2">
            <span>Total ({selectedBills.length} bills):</span>
            <span className="fw-bold">${totalAmount.toFixed(2)}</span>
          </div>
          <div className="mb-2">
            <small>Budget: {percentage.toFixed(1)}%</small>
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: `${Math.min(percentage, 100)}%` }}
              />
            </div>
          </div>
          <Collapse in={!isMinimized && showBreakdown}>
            <ListGroup variant="flush">
              <div className="selected-bills-list">
                {selectedBills.map(bill => (
                  <ListGroup.Item key={bill.id} className="d-flex justify-content-between">
                    <span>{bill.name}</span>
                    <span>${bill.amount}</span>
                  </ListGroup.Item>
                ))}
              </div>
            </ListGroup>
          </Collapse>
          {!isMinimized && (
            <Button
              variant="outline-danger"
              size="sm"
              className="mt-2 w-100"
              onClick={onClearAll}
            >
              Clear All
            </Button>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default BillSelectionTotal;
